import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaCalendarAlt, FaMoneyBillWave, FaCog, FaSignOutAlt, FaBars, FaTimes, FaBed, FaChevronLeft, FaChevronRight, FaStar } from 'react-icons/fa';
import { supabase } from '../lib/supabaseClient';

const AdminSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', icon: FaBed, label: 'Reservas', color: 'blue' },
    { path: '/admin/quotes', icon: FaHome, label: 'Cotizaciones Casa', color: 'green' },
    { path: '/admin/calendar', icon: FaCalendarAlt, label: 'Calendario', color: 'purple' },
    { path: '/admin/prices', icon: FaMoneyBillWave, label: 'Precios', color: 'teal' },
    { path: '/admin/reviews', icon: FaStar, label: 'Reseñas', color: 'yellow' },
    { path: '/admin/settings', icon: FaCog, label: 'Ajustes', color: 'gray' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 bg-white p-3 rounded-lg shadow-lg hover:bg-gray-50 transition-colors"
      >
        {isOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>

      {/* Desktop Toggle Button */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="hidden lg:block fixed top-4 z-50 bg-white p-3 rounded-lg shadow-lg hover:bg-gray-50 transition-all"
        style={{ left: isCollapsed ? '80px' : '256px' }}
      >
        {isCollapsed ? <FaChevronRight size={16} /> : <FaChevronLeft size={16} />}
      </button>

      {/* Overlay para móvil */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 h-full bg-white shadow-xl z-40 transition-all duration-300
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0
          ${isCollapsed ? 'lg:w-20' : 'w-64'}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="p-6 border-b border-gray-200">
            <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'gap-3'}`}>
              <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-2xl">SM</span>
              </div>
              {!isCollapsed && (
                <div>
                  <h2 className="font-bold text-gray-900 text-lg">Sumaq Mayu</h2>
                  <p className="text-xs text-gray-500">Panel Admin</p>
                </div>
              )}
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);
              
              return (
                <button
                  key={item.path}
                  onClick={() => {
                    navigate(item.path);
                    setIsOpen(false);
                  }}
                  className={`
                    w-full flex items-center ${isCollapsed ? 'justify-center' : 'gap-3'} px-4 py-3 rounded-lg transition-all
                    ${active
                      ? `bg-${item.color}-50 text-${item.color}-700 font-semibold`
                      : 'text-gray-700 hover:bg-gray-100'
                    }
                  `}
                  title={isCollapsed ? item.label : ''}
                >
                  <Icon 
                    size={28} 
                    className={active ? `text-${item.color}-600` : 'text-gray-500'}
                  />
                  {!isCollapsed && (
                    <>
                      <span className="flex-1 text-left">{item.label}</span>
                      {active && (
                        <div className={`w-1.5 h-1.5 rounded-full bg-${item.color}-600`} />
                      )}
                    </>
                  )}
                </button>
              );
            })}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200">
            <button
              onClick={handleLogout}
              className={`w-full flex items-center ${isCollapsed ? 'justify-center' : 'gap-3'} px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition-all`}
              title={isCollapsed ? 'Cerrar Sesión' : ''}
            >
              <FaSignOutAlt size={20} />
              {!isCollapsed && <span className="font-medium">Cerrar Sesión</span>}
            </button>
          </div>
        </div>
      </aside>

      {/* Spacer para el contenido principal en desktop */}
      <div className={`hidden lg:block transition-all duration-300 ${isCollapsed ? 'w-20' : 'w-64'}`} />
    </>
  );
};

export default AdminSidebar;
